import { FC } from 'react';
import styles from './index.module.less';
import { IEfficiencyBannerData } from '@pro/linearTopLight/interface';
import { ProdOverlayBanner } from '@app/linearTopLight/ProdOverlayBanner';
import { ModuleHeader } from '@app/linearTopLight/ModuleHeader';

type IEfficiencyBannerProps = {
    data: IEfficiencyBannerData;
};

export const EfficiencyBanner: FC<IEfficiencyBannerProps> = props => {
    const { data } = props;

    return (
        <ProdOverlayBanner data={data} className={styles['efficiency-banner']}>
            <ModuleHeader
                className={styles.header}
                title={data.title}
                description={data.description}
            />
        </ProdOverlayBanner>
    )
};
